export default __webpack_public_path__ + "static/media/checkbox-unchecked-yono@2x.1de29b8b.png";